import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import {
    openSidePropertiesState,
    type SidePropertiesSubject,
} from '~/state/atoms/viewerAtoms';

/**
 * The side properties panel of `subject`: whether it is open, and opening
 * and closing it. At most one side panel is open at a time, so opening this
 * one replaces any other. Closing it closes this one only: a panel of
 * another subject, opened since, stays open.
 */
export function useSidePropertiesPanel(subject: SidePropertiesSubject) {
    const [openSubject, setOpenSubject] = useRecoilState(
        openSidePropertiesState
    );
    const open = useCallback(
        () => setOpenSubject(subject),
        [setOpenSubject, subject]
    );
    const close = useCallback(
        () =>
            setOpenSubject((current) => (current === subject ? null : current)),
        [setOpenSubject, subject]
    );
    return { isOpen: openSubject === subject, open, close };
}
